export default {
  Lato: 'Lato',
  Oswald: 'Oswald',
  SourceSansPro: 'Source Sans Pro',
  SourceSelfPro: 'Source Self Pro',
  defaultSansFont: '400 Source Sans Pro',
  Roboto: 'Roboto, sans-serif'
}
